export default __webpack_public_path__ + "static/media/SobDemanda.fdee6833.png";